import { gql } from 'core/dna/types/apollo';

export const GET_TERMS_STATE_QUERY = gql`
  query GetTermsState {
    termsState @client {
      selected
    }
  }
`;
